/*
  Class Helper
  Do more with classes
*/

// Class Definition
export class ClassHelper {
  static camelize(str: string): string {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return str.replace(/(?:^\w|[A-Z]|_\w|\b\w|\s+\w)/g, (match, index) => {
      match = match.replace(/[\s_-]/g, '');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return,eqeqeq
      return index == 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }
}
